<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateExtraModel from "./create-extra";
import EditExtraModel from "./edit-extra";
import DeleteExtraModel from "./delete-extra";
import { getAddOns } from "../../../api/services/addon.service";

/**
 * Manage Extras Page
 */
export default {
  page: {
    title: "Manage Extras",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    "create-extra-model": CreateExtraModel,
    "edit-extra-model": EditExtraModel,
    "delete-extra-model": DeleteExtraModel,
  },
  data() {
    return {
      title: this.$i18n.t("extras.header.title"),
      items: [
        {
          text: this.$i18n.t("extras.header.item"),
          active: true,
        },
      ],
      extras: null,
      extraToEdit: null,
      extraToDelete: null,
      showCreateExtraModel: false,
      showEditExtraModel: false,
      showDeleteExtraModel: false,
    };
  },
  async mounted() {
    await this.getAllExtras();
  },
  methods: {
    clickCreateNewExtra() {
      this.showCreateExtraModel = true;
    },
    realodPage() {
      window.location.reload();
    },
    async getAllExtras() {
      let getAllExtras = await getAddOns();
      if (getAllExtras.length > 0) {
        this.extras = getAllExtras;
      }
    },
    clickEditExtra(extraId) {
      this.extraToEdit = extraId;
      this.showEditExtraModel = true;
    },
    clickDeleteExtra(extraId) {
      this.extraToDelete = extraId;
      this.showDeleteExtraModel = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-6 col-xl-6 mb-4">
        <div
          class="p-3 text-center"
          style="
            border-radius: 4px;
            border: 2px dashed #a5a5a5;
            color: #a5a5a5;
            background: #fff;
            cursor: pointer;
            height: 150px;
          "
          @click="clickCreateNewExtra()"
        >
          <b-row>
            <b-col md="3">
              <b-img
                class="mb-3"
                alt=""
                :src="require('@/assets/images/Create Extra.png')"
                style="height: 120px"
              ></b-img>
            </b-col>
            <b-col md="9">
              <h6 class="mt-5">
                <i class="bx bx-plus-medical bx-tada mr-2"></i>
                {{ $t("extras.createExtraButton") }}
              </h6>
            </b-col>
          </b-row>
        </div>
      </div>
      <!-- Simple Extra Card -->
      <div
        class="col-md-12 col-lg-6 col-xl-6 mb-4"
        v-for="(extra, extraIndex) in extras"
        :key="extraIndex"
      >
        <b-card style="height: 150px" no-body class="overflow-hidden p-3">
          <b-row>
            <b-col md="3">
              <b-card-img
                v-if="extra.image"
                :src="extra.image"
                alt="Image"
                class="rounded-0"
                style="height: 120px; width: 120px"
              ></b-card-img>
              <b-card-img
                v-else
                src="https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/images/ms-sissi-extra-default.png"
                alt="Image"
                class="rounded-0"
                style="height: 120px; width: 120px"
              ></b-card-img>
            </b-col>
            <b-col md="9">
              <b-card-title>
                <h5 class="card-title text-limted-one-lines">
                  {{ extra.title }}
                </h5>
              </b-card-title>
              <b-card-text class="text-limted-two-lines">
                {{ extra.description }}
              </b-card-text>
              <b-button variant="warning" @click="clickEditExtra(extra.id)">
                <i class="bx bxs-pencil mr-1"></i>
                {{ $t("general.buttons.edit") }}
              </b-button>
              <b-button
                class="ml-2"
                variant="danger"
                @click="clickDeleteExtra(extra.id)"
              >
                <i class="bx bx-trash-alt mr-1"></i>
                {{ $t("general.buttons.delete") }}</b-button
              >
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
    <!-- end row -->

    <!-- Create Subpackage Model -->
    <create-extra-model
      v-if="showCreateExtraModel === true"
      :visible="showCreateExtraModel"
      @close="showCreateExtraModel = false"
      @reload="realodPage()"
    />

    <!-- Delete Subpackage Model -->
    <delete-extra-model
      v-if="showDeleteExtraModel === true"
      :visible="showDeleteExtraModel"
      @close="showDeleteExtraModel = false"
      @reload="realodPage()"
      :extraID="extraToDelete"
    />

    <!-- Edit Subpackage Model -->
    <edit-extra-model
      v-if="showEditExtraModel === true"
      :visible="showEditExtraModel"
      @close="showEditExtraModel = false"
      @reload="realodPage()"
      :extraID="extraToEdit"
    />
  </Layout>
</template>

<style scoped>
.text-limted-one-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.text-limted-two-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
